<template>
  <pagefra>
    <div
      class="elevtorVideo"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel>
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('电梯工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('设备号')">
              <el-input
                v-model="form.deviceSerial"
                :placeholder="$l('设备号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('设备名称')">
              <el-input
                v-model="form.deviceName"
                :placeholder="$l('设备名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('设备类型')">
              <el-select
                v-model="form.deviceType"
                :placeholder="$l('设备类型')"
              >
                <el-option :label="$l('设备类型')" value="-1"></el-option>
                <el-option :label="$l('W22')" value="1"></el-option>
                <el-option :label="$l('萤石云')" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('设备状态')">
              <el-select
                v-model="form.deviceStatus"
                :placeholder="$l('设备状态')"
              >
                <el-option :label="$l('设备状态')" value="-1"></el-option>
                <el-option :label="$l('离线')" value="0"></el-option>
                <el-option :label="$l('在线')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd()"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              round
              @click="deleteVideo"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
            <el-button
              type="success"
              round
              icon="el-icon-download"
              @click="openImportDevice"
              v-if="hasPermission('导入')"
              >{{ $l("导入") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('设备类型')"
              prop="deviceType"
              align="center"
              min-width="100"
              :formatter="deviceTypeFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('设备号')"
              prop="deviceSerial"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('通道号')"
              prop="channelNo"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('设备名称')"
              prop="deviceName"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('设备状态')"
              prop="deviceStatus"
              align="center"
              width="120"
              :formatter="deviceStatusFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('硬盘状态')"
              prop="diskStatus"
              align="center"
              width="120"
              :formatter="diskStatusFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createDate"
              align="center"
              width="200"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('视频对讲')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('视频对讲')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openIntercom(scope.row)"
                  class="table-icon"
                  v-if="scope.row.deviceType == 2"
                >
                  <svgicon name="intercom" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('视频监控')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('视频监控')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="videoMonitor(scope.row)"
                  class="table-icon"
                >
                  <svgicon name="camera" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        ref="editDialog"
        :visible.sync="editDialogVisible"
        width="540px"
      >
        <div slot="title" class="dialog-title">
          {{ $l(editDialogTitle) }}
          <el-popover placement="right" width="300" trigger="click">
            <slot>{{
              $l(
                "目前只支持我司的ESC-D4-AI型号摄像头，并且已接入遥监平台或萤石云平台。接入遥监平台的设备（W22）添加“电梯工号”后可查看实时视频；接入萤石云的视频添加电梯工号、设备号和通道号后可查看实时视频和历史视频。"
              )
            }}</slot>
            <i
              class="el-icon-question"
              slot="reference"
              style="cursor: pointer"
            ></i>
          </el-popover>
        </div>
        <el-form
          ref="editForm"
          :model="editForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="rules"
        >
          <el-form-item :label="$l('电梯工号')" prop="jobNum">
            <span class="required">*</span>
            <el-input v-model="editForm.jobNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('设备类型')">
            <el-select v-model="editForm.deviceType">
              <el-option :label="$l('W22')" value="1"> </el-option>
              <el-option :label="$l('萤石云')" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('设备名称')">
            <el-popover placement="right" width="300" trigger="focus">
              <slot>{{
                $l(
                  "建议命名规则：地盘名称+楼栋+具体位置，例：万科小区1栋客梯轿厢"
                )
              }}</slot>
              <el-input
                v-model="editForm.deviceName"
                slot="reference"
              ></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item
            :label="$l('设备号')"
            prop="deviceSerial"
            v-if="editForm.deviceType == 2"
          >
            <span class="required">*</span>
            <el-input v-model="editForm.deviceSerial"></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('通道号')"
            prop="channelNo"
            v-if="editForm.deviceType == 2"
          >
            <span class="required">*</span>
            <el-input-number
              v-model="editForm.channelNo"
              :min="1"
              :max="999999999"
              :label="$l('通道号')"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$l('默认')">
            <el-checkbox v-model="editForm.defaulted" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="editDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="submit"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('导入视频设备')"
        :visible.sync="importDeviceDialogVisible"
        width="30%"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :limit="2"
          :file-list="fileList"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          list-type="text"
          :auto-upload="false"
        >
          <el-button size="small" round type="primary"
            >{{ $l("点击上传") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $l("只能上传xlsx文件") }}

            <a
              href="#"
              style="text-decoration: none"
              @click="downloadTemplate('视频设备信息模板.xlsx')"
              >{{ $l("模板文件") }}
            </a>
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDeviceDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="importVideoDevice"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>

      <videoMonitor ref="video"></videoMonitor>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import videoMonitor from "@/components/videoMonitor.vue";
import global from "@/mixins/global.js";
export default {
  name: "elevatorVideo",
  mixins: [global],
  components: {
    panel,
    videoMonitor,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateDeviceSerial = (rule, value, callback) => {
      if (
        this.editForm.deviceType == 2 &&
        (value == null || value.trim().length == 0 || value.length > 50)
      ) {
        callback(new Error(this.$l("请输入设备号，且长度不超过50个字符!")));
      } else {
        callback();
      }
    };
    return {
      form: {
        jobNum: "",
        deviceSerial: "",
        deviceName: "",
        deviceType: "-1",
        deviceStatus: "-1",
      },
      tableData: [],
      selectedList: [],
      loading: false,
      fullLoading: false,
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        videoId: null,
        jobNum: null,
        deviceName: null,
        channelNo: null,
        deviceSerial: null,
        deviceType: "2",
        defaulted: false,
      },
      rules: {
        jobNum: [
          {
            min: 9,
            max: 9,
            message: this.$l("长度为 9 个字符"),
            trigger: "blur",
          },
        ],
        deviceSerial: [{ validator: validateDeviceSerial, trigger: "blur" }],
      },
      importDeviceDialogVisible: false,
      fileList: [],
      file: null,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_elevator_video_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showAdd() {
      for (let key in this.editForm) {
        this.editForm[key] = null;
        this.editForm.deviceType = "2";
      }
      this.editDialogTitle = "新建视频设备";
      this.editDialogVisible = true;
      this.editForm.videoId = null;
    },
    showEdit(row) {
      for (let key in this.editForm) {
        this.editForm[key] = null;
        this.editForm.deviceType = "2";
      }
      this.editDialogTitle = "编辑视频设备";
      this.editDialogVisible = true;
      this.$http
        .get(this.$apiConfig.get_elevator_video_url + row.videoId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = result.data[key];
            }
            this.editForm.deviceType += "";
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_elevator_video_url, this.editForm)
            .then((response) => {
              let data = response.data;
              this.message(data.code, data.msg);
              if (data.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteVideo() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].videoId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_elevator_video_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
    onFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
      this.file = file.raw;
    },
    onFileRemove() {
      this.file = null;
    },
    openImportDevice() {
      this.fileList = [];
      this.file = null;
      this.importDeviceDialogVisible = true;
    },
    importVideoDevice() {
      if (this.file == null) {
        this.message(1, "请选择要上传的文件");
        return;
      }
      if (!this.file.name.endsWith(".xlsx")) {
        this.message(1, "文件类型错误，请选择类型为xlsx的文件");
        return;
      }
      this.fullLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.$http
        .post(this.$apiConfig.import_video_device_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.importDeviceDialogVisible = false;
            this.search();
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    downloadTemplate(fileName) {
      this.$http({
        url: this.$apiConfig.download_template_url + "?fileName=" + fileName,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          const status = response.status;
          if (status != 200) {
            this.message(1, "下载失败");
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = fileName;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    openIntercom(row) {
      row.playType = 3;
      row.pageInfo = "PC端-视频设备管理-视频对讲";
      this.$refs.video.playVideo(2, row);
    },
    videoMonitor(row) {
      row.playType = 1;
      row.pageInfo = "PC端-视频设备管理-视频监控";
      this.$refs.video.playVideo(2, row);
    },
    deviceTypeFormatter(row) {
      if (row.deviceType == 1) {
        return "W22";
      }
      return "萤石云";
    },
    deviceStatusFormatter(row) {
      if (row.deviceStatus == 0) {
        return "离线";
      } else if (row.deviceStatus == 1) {
        return "在线";
      }
      return "";
    },
    diskStatusFormatter(row) {
      if (row.diskStatus == 0) {
        return "正常";
      } else if (row.diskStatus == 1) {
        return "存储介质错";
      } else if (row.diskStatus == 2) {
        return "未格式化";
      } else if (row.diskStatus == 3) {
        return "正在格式化";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.elevtorVideo {
  .dialog-form {
    .el-input {
      width: 300px;
    }
    .el-select {
      width: 300px;
    }
    /deep/ .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
      width: 300px;
    }
    .required {
      color: red;
      display: inline-block;
      position: absolute;
      left: -10px;
      top: 2px;
    }
  }
}
</style>
